<div class="login_page">
  <div class="illustration left" [class]="'entry-' + entryPoint">
    <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
    <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
    <img src="assets/images/login/road.png" alt="Road Illustration" />
  </div>

  <div class="login_card">
    <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
    <div class="quote">
      <img src="assets/images/login/smiley.png" class="smiley" alt="Smiley" />
      <span class="quote-text">
        {{ currentQuote }}
      </span>
    </div>

    <form *ngIf="!showAgencySelection" [formGroup]="loginForm" (ngSubmit)="onFormSubmit($event)">
      <div class="input_group">
        <div class="form-fields input-with-success">
          <input type="text" id="email" formControlName="email" placeholder="Enter Email / Phone Number"
            [class.is-invalid]="(email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']"
            [class.is-valid]="email?.valid && email?.touched" (focus)="onEmailFocus()" (input)="onEmailInput()"
            (keyup)="onEmailKeyup($event)" appPreventLeadingSpace />
          <span class="success-circle" *ngIf="email?.valid && email?.touched">
          </span>
          <span class="error-circle"
            *ngIf="(email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']">
          </span>
          <div class="validation_error"
            *ngIf="email?.invalid && (isEmailTyping || email?.touched) && !email?.errors?.['backendError']">
            {{ getErrorMessage('email') }}
          </div>
        </div>
      </div>

      <div class="input_group mt-3">
        <div class="passcode_wrapper">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="passcode" placeholder="Password"
            (input)="onPasswordInput()"
            [class.is-invalid]="(passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] || email?.errors?.['backendError']"
            [class.is-valid]="passcode?.valid && passcode?.touched" (focus)="onPasswordFocus()" />
          <span class="success-circle"
            *ngIf="passcode?.valid && passcode?.touched && (errorMessage !== 'Password incorrect. Please try again')">
          </span>
          <span class="error-circle"
            *ngIf="(passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] || email?.errors?.['backendError']">
          </span>
          <span class="toggle" (click)="togglePassword()">{{ showPassword ? 'Hide' : 'Show' }}</span>
        </div>
        <div class="validation_error nw_pss_err"
          *ngIf="passcode?.invalid && (isPasswordTyping || passcode?.touched) && !passcode?.errors?.['backendError']">
          {{ getErrorMessage('passcode') }}
        </div>
      </div>

      <div class="error_wrap" [ngClass]="{ 'show': errorMessage }">
        <div class="error_message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
      </div>
      <small class="back-link help_text"><a href="#/forgotpassword">Having trouble signing in? </a></small>

      <button type="submit" [disabled]="isLoading">
        <span *ngIf="!isLoading">Sign In</span>
        <app-spinner *ngIf="isLoading" [size]="16"></app-spinner>
      </button>
    </form>

    <form *ngIf="showAgencySelection" [formGroup]="agencyForm" (ngSubmit)="onAgencyFormSubmit($event)">
      <h2>Select Agency</h2>
      <p>Please select an agency to continue</p>

      <div class="agency_tag_wrapper">
        <a *ngFor="let agency of visibleAgencies() trackBy: trackByAgencyId"
          [class.selected]="agencyForm.get('agency')?.value === agency._id" (click)="selectAgency(agency._id)"
          class="agency-tag">
          {{ agency.name }}
        </a>
        <!-- <a 
          *ngFor="let agency of visibleAgencies" 
          [class.selected]="agencyForm.get('agency')?.value === agency.id"
          (click)="selectAgency(agency.id)"
          class="agency-tag"
        >
          <img src="{{ agency.name }}" alt="Agency Logo">
        </a> -->

      <a *ngIf="agencies().length > 2" class="next_btn" (click)="nextSlide()"
          [class.disabled]="currentIndex() >= agencies().length - 2">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
        <a *ngIf="agencies().length > 2" class="prev_btn" (click)="prevSlide()" [class.disabled]="currentIndex() === 0">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
      </div>
      <div class="btn_wrap">
        <a href="#/login" class="back-link">Back to Login</a>
        <button type="submit" [disabled]="isLoading">
          <span *ngIf="!isLoading">Continue</span>
          <app-spinner *ngIf="isLoading" [size]="16"></app-spinner>
        </button>
      </div>
    </form>

    <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
  </div>

  <div class="illustration right">
    <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
    <img src="assets/images/login/moon.png" alt="Moon Illustration" />
  </div>

</div>
<footer>© 2000–{{ currentYear }} Licenced Copyright by TechWyse. All rights reserved.</footer>